import { GET_AWBS_GHA_SUCCEEDED } from '../actions/actionTypes';
import Awb from '../../models/Awb';

const initialState: Awb[] = [];

export const awbsGhaReducer = (state:Awb[] = initialState, action: any) => {
  switch (action.type) {
    case GET_AWBS_GHA_SUCCEEDED:
      return [...action.payload ]; 
    default:
     return state;
  }
};